import type { ResumptionRequestFormValues } from '../types';

export const initialFormValues: ResumptionRequestFormValues = {
  resumingFromLeaveRequestId: null,
  resumingFromLeaveRequestEndDate: null,
  resumingOnDate: '',
  workShift: 1,
  currentLocation: '',
  remarks: '',
  totDays: '',
};
